import { render, staticRenderFns } from "./tuiguang.vue?vue&type=template&id=43b4b6eb&scoped=true&"
import script from "./tuiguang.vue?vue&type=script&lang=js&"
export * from "./tuiguang.vue?vue&type=script&lang=js&"
import style0 from "./tuiguang.vue?vue&type=style&index=0&id=43b4b6eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b4b6eb",
  null
  
)

export default component.exports